import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import WhySpeed from './components/WhySpeed';
import HowItWorks from './components/HowItWorks';
import WhatWeDo from './components/WhatWeDo';
import WhyBuildToLead from './components/WhyBuildToLead';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Problem />
      <WhySpeed />
      <HowItWorks />
      <WhatWeDo />
      <WhyBuildToLead />
      <Contact />
      <Footer />
    </div>
  );
}
